<template>
  <div class="cal-container">
    <canvas class="cal-canvas" ref="cal"> </canvas>
  </div>
</template>
<script>
export default {
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    value: {
      default: 0
    }
  },
  data() {
    return {
      curValue: 0, //当前显示的值
      cWidth: 0, //canvas宽度
      cHeight: 0, //canvas高度
      timer: null, //全局定时器
      scoreList: [0, 20, 40, 60, 80, 100],
      ctx: null, //绘画上下文
      calText: '', // 当前食物的热量状态 高中低
      styleObj: {},
      linergradientColor: ['#4A3D6B', '#6236FF', '#FF2B48'],
      bgcolor: '#ECEAF0', //圆环背景颜色
      content: null,
      lineWidth: 24, //圆环宽度
      statusFont: 18, // 良好 优良等字体大小
      scoreFont: 50,
      scoreTextFont: 16,
      bottomSpace: 5 // 圆环距离底部的距离
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    filterText(value) {
      if (value >= 150) {
        return '高热量'
      } else if (value <= 40) {
        return '低热量'
      }
      return '中热量'
    },
    init() {
      this.curValue = this.min
      this.calText = this.filterText(this.value)
      let canvas = this.$refs.cal
      canvas.width = 440
      canvas.height = 440
      this.cWidth = canvas.width
      this.cHeight = canvas.height
      this.ctx = canvas.getContext('2d')
      this.animateCal()
    },
    //canvas动画效果
    animateCal() {
      let step = Math.floor(this.max / 100) || 1
      this.timer = setInterval(() => {
        this.drawFrame()
        this.curValue = this.curValue + step
        if (this.curValue > this.value) {
          this.curValue = this.value
          this.drawFrame()
          clearInterval(this.timer)
        }
      }, 10)
    },
    drawFrame() {
      this.ctx.clearRect(0, 0, this.cWidth, this.cHeight)
      this.backgroundCircle(this.ctx)
      this.drawLineList(this.ctx)
      this.drawText(this.ctx)
      this.drawLineList(this.ctx)
      this.foregroundCircle(this.ctx)
      this.drawDot(this.ctx)
    },
    //绘制刻度条列表
    drawLineList(ctx) {
      for (var i = 0; i < 19; i++) {
        this.getLine(
          ctx,
          1.25 * Math.PI + ((1.5 * Math.PI) / 18) * i,
          -180,
          -166,
          '#d8d8d8',
          6
        )
      }
    },
    // 定义生成刻度方法
    getLine(cxt, rotate, moveTo, lineTo, color, width) {
      cxt.save()
      cxt.translate(this.cWidth / 2, this.cHeight / 2)
      cxt.rotate(rotate)
      cxt.beginPath()
      cxt.moveTo(0, moveTo)
      cxt.lineTo(0, lineTo)
      cxt.closePath()
      cxt.strokeStyle = color
      cxt.lineWidth = width
      cxt.stroke()
      cxt.restore()
    },
    //绘制两个圆圈
    drawDot(ctx) {
      let center_x = this.cWidth / 2
      let center_y = this.cHeight / 2
      var radius = center_x - this.lineWidth / 2
      let space = radius * Math.sin(0.25 * Math.PI)
      ctx.beginPath()
      ctx.lineWidth = 16
      ctx.strokeStyle = '#4A3D6B'
      ctx.arc(center_x - space, center_y + space, 12, 0, 2 * Math.PI, false)
      ctx.stroke()
      ctx.fillStyle = '#ffffff'
      ctx.fill()
      ctx.beginPath()
      ctx.strokeStyle = '#FF2B48'
      ctx.arc(center_x + space, center_y + space, 12, 0, 2 * Math.PI, false)
      ctx.stroke()
      ctx.fillStyle = this.value >= this.max ? '#FFA7B3' : '#FFFFFF'
      ctx.fill()
      ctx.closePath()
    },
    // 绘制背景圆圈
    backgroundCircle(context) {
      let center_x = this.cWidth / 2
      let center_y = this.cHeight / 2
      context.save()
      context.beginPath()
      context.lineWidth = this.lineWidth //设置线宽
      var radius = center_x - this.lineWidth / 2
      context.lineCap = 'round'
      context.strokeStyle = this.bgcolor
      context.arc(
        center_x,
        center_y,
        radius,
        1.25 * -Math.PI,
        0.25 * Math.PI,
        false
      )
      context.stroke()
      context.closePath()
      context.restore()
    },
    //绘制文字
    drawText(context) {
      let desc = {
        text: '每百克热量',
        fontSize: '24px PingFangSC-Semibold',
        lineHeight: 24,
        color: '#000000',
        style: 'bold'
      }
      let calNumer = {
        text: this.curValue,
        fontSize: '108px DINCondensed-Bold, DINCondensed',
        lineHeight: 108,
        color: '#000000',
        style: 'bold'
      } // 卡路里数字
      let status = {
        text: this.calText,
        fontSize: '24px',
        lineHeight: 42,
        color: '#ffffff',
        style: 'bold'
      }
      let unit = {
        text: 'kcal',
        color: '#000000',
        fontSize: '24px',
        lineHeight: 34,
        style: 'bold'
      }
      let center_x = this.cWidth / 2
      let center_y = this.cHeight / 2
      context.save() //save和restore可以保证样式属性只运用于该段canvas元素
      var text_width
      //渲染描述文字
      context.fillStyle = desc.color
      context.font = desc.fontSize + ' ' + desc.style
      text_width = context.measureText(desc.text).width
      context.fillText(
        desc.text,
        center_x - text_width / 2,
        center_y - calNumer.lineHeight / 2 - 28 - desc.lineHeight / 2
      )
      //开始渲染卡路里文字大小
      context.fillStyle = calNumer.color
      context.font = calNumer.fontSize + ' ' + calNumer.style
      text_width = context.measureText(calNumer.text).width
      context.fillText(
        calNumer.text,
        center_x - text_width / 2,
        center_y + calNumer.lineHeight / 2 - 10
      )
      //绘制kcal文字
      context.fillStyle = unit.color
      context.font = unit.fontSize + ' ' + unit.style
      text_width = context.measureText(unit.text).width
      context.fillText(
        unit.text,
        center_x - text_width / 2,
        center_y + calNumer.lineHeight / 2 + unit.lineHeight
      )
      //绘制热量等级
      text_width = context.measureText(status.text).width
      context.fillStyle = '#FFB300'
      let rectWidth = text_width + 30 * 2
      let rectHeight = status.lineHeight
      this.roundRect(
        context,
        center_x - rectWidth / 2,
        center_y +
          calNumer.lineHeight / 2 +
          20 +
          unit.lineHeight +
          20 -
          rectHeight / 2,
        text_width + 30 * 2,
        status.lineHeight,
        6
      )
      context.fillStyle = status.color
      context.font = status.fontSize + ' ' + status.style
      context.fillText(
        status.text,
        center_x - text_width / 2,
        center_y + calNumer.lineHeight / 2 + 20 + unit.lineHeight + 20 + 8
      )
      context.restore()
    },
    //绘制圆角矩形
    //绘制圆角矩形
    roundRect(ctx, x, y, w, h, r) {
      ctx.save()
      if (w < 2 * r) {
        r = w / 2
      }
      if (h < 2 * r) {
        r = h / 2
      }
      ctx.beginPath()
      ctx.moveTo(x + r, y)
      ctx.arcTo(x + w, y, x + w, y + h, r)
      ctx.arcTo(x + w, y + h, x, y + h, r)
      ctx.arcTo(x, y + h, x, y, r)
      ctx.arcTo(x, y, x + w, y, r)
      ctx.fill()
      ctx.closePath()
    },
    //绘制运动圆环
    foregroundCircle(context) {
      var rad = (1.5 * Math.PI) / (this.max - this.min)
      let center_x = this.cWidth / 2
      let center_y = this.cHeight / 2
      context.save()
      /*  */
      //创建渐变对象
      var gr = context.createLinearGradient(0, 0, this.cWidth, 0)
      //颜色断点
      gr.addColorStop(0, this.linergradientColor[0])
      gr.addColorStop(0.5, this.linergradientColor[1])
      gr.addColorStop(1, this.linergradientColor[2])
      //设置渐变
      context.strokeStyle = gr
      /*  */
      //context.strokeStyle = forecolor;
      context.lineWidth = this.lineWidth //设置线宽
      context.lineCap = 'round'
      var radius = center_x - this.lineWidth / 2
      context.beginPath()
      let rotate = this.curValue * rad
      let maxRotate = 1.5 * Math.PI
      rotate = rotate >= maxRotate ? maxRotate : rotate
      context.arc(
        center_x,
        center_y,
        radius,
        1.25 * -Math.PI,
        1.25 * -Math.PI + rotate,
        false
      ) //用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
      context.stroke()
      context.closePath()
      context.restore()
    }
  }
}
</script>
<style lang="scss" scoped>
.cal-container {
  width: 100%;
  height: 220px;
}
.cal-canvas {
  width: 100%;
  height: 100%;
}
</style>
